export default (num, decimals = 2, showSign = true) =>
  Intl.NumberFormat('en-US', {
    style: showSign ? 'currency' : 'decimal',
    currency: 'USD',
    minimumFractionDigits: decimals,
  }).format(num);
